/**
 * Pub/sub minimale per i domini di dati cambiati (come su gestionale-gls):
 * lo alimentano mutationInvalidator (mutazione locale) e useRealtimeSync
 * (evento WS da altri client), per i componenti che non usano React Query.
 */
const listeners = new Set();

export function emitDomainChanged(domain) {
  listeners.forEach((fn) => {
    try {
      fn(domain);
    } catch (_) {
      // un listener non deve mai bloccare gli altri
    }
  });
}

export function onDomainChanged(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
